import { createAction, props } from '@ngrx/store';
import { UserEvent } from 'src/app/features/smart-inbox/services/realtime.service';
import { GetNotificationsParams, INotificationItem, NotificationListMetadata } from '../models/notification.models';

// ─── Unread Count (from SSE) ─────────────────────────────────────────────────

export const SetUnreadCount = createAction(
  '[ Notifications ] - SetUnreadCount',
  props<{ count: number }>()
);

export const IncrementUnreadCount = createAction(
  '[ Notifications ] - IncrementUnreadCount'
);

// ─── Load Notifications ──────────────────────────────────────────────────────

export const LoadNotifications = createAction(
  '[ Notifications ] - LoadNotifications',
  props<{ params?: GetNotificationsParams }>()
);

export const LoadNotificationsSuccess = createAction(
  '[ Notifications ] - LoadNotifications Success',
  props<{ notifications: INotificationItem[]; metadata: NotificationListMetadata }>()
);

export const LoadNotificationsError = createAction(
  '[ Notifications ] - LoadNotifications Error'
);

// ─── Mark As Read ────────────────────────────────────────────────────────────

export const MarkAsRead = createAction(
  '[ Notifications ] - MarkAsRead',
  props<{ id: number }>()
);

export const MarkAsReadSuccess = createAction(
  '[ Notifications ] - MarkAsRead Success',
  props<{ id: number }>()
);

export const MarkAsReadError = createAction(
  '[ Notifications ] - MarkAsRead Error',
  props<{ id: number }>()
);

// ─── Mark All As Read ────────────────────────────────────────────────────────

export const MarkAllAsRead = createAction(
  '[ Notifications ] - MarkAllAsRead'
);

export const MarkAllAsReadSuccess = createAction(
  '[ Notifications ] - MarkAllAsRead Success',
  props<{ updatedCount: number }>()
);

export const MarkAllAsReadError = createAction(
  '[ Notifications ] - MarkAllAsRead Error'
);

// ─── New Notification (from SSE) ─────────────────────────────────────────────

export const NewNotificationReceived = createAction(
  '[ Notifications ] - NewNotificationReceived',
  props<{ notification: INotificationItem }>()
);

// ─── Raw SSE User Event ──────────────────────────────────────────────────────

export const UserEventReceived = createAction(
  '[ Notifications ] - UserEventReceived',
  props<{ event: UserEvent }>()
);
